import React from 'react';
import BuySellsPage from '../buySells/BuySellsPage.jsx';

const WipBuySellsPage = () => <BuySellsPage showWipBadge />;

export default WipBuySellsPage;
